var alignment_default = {
  "alignLeft": "BS4JL",
  "textWrapNowrap": "_0B1pq",
  "alignRight": "PF7Kr",
  "alignCenter": "Ca6c9",
  "sizeFullWidth": "_7x6NG",
  "renderedInTable": "BcAMd",
  "sizeOriginal": "ox6T9",
  "sizeContent": "cWt7k",
  "sizeSmall": "kHh-O",
  "sizeSmallCenter": "uFfJi",
  "flex": "MWtfN",
  "LEFT": "Yio-i",
  "CENTER": "_6V-OU",
  "RIGHT": "HrJC2",
  "AUTO": "M4Ji4",
  "JUSTIFY": "_7wrCx"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
